import { ConfirmDialog } from '@internal/backstage-plugin-devops-react';
import { useAccountsContext } from '../Providers';

interface DeleteEntityDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export function DeleteAccountDialog(props: Readonly<DeleteEntityDialogProps>) {
  const { isOpen } = props;

  const { selectedAccount, unselectAccount, deleteAccount } =
    useAccountsContext();

  const onClose = () => {
    unselectAccount();
    props.onClose();
  };

  const onSubmit = async () => {
    if (selectedAccount === undefined) {
      return;
    }

    deleteAccount();
    props.onClose();
  };

  return (
    <ConfirmDialog
      isOpen={isOpen}
      title="Confirm Account Deletion"
      description=""
      onClose={onClose}
      onConfirm={onSubmit}
    />
  );
}
